import { IIndicator, UIErrorHandlingService } from "@gtmhub/error-handling";
import { FilterType, IEntry, ISelection } from "@gtmhub/configuration/workday/models";
import { WorkdayUserProvisioningService } from "@gtmhub/configuration/workday/workday-user-provisioning-service";
import { StateService } from "@uirouter/angularjs";
import { IScope } from "angular";

interface ISelectionMapService {
  selectionId: string;
}

export class WizardSelectionCtrl {
  indicators: {
    loading?: IIndicator;
    loadingJobLevels?: IIndicator;
  };
  count = 0;
  isNameEditable: boolean;
  selectionId: string;
  selection: ISelection;
  jobLevels: IEntry[] = [];
  static $inject = ["$scope", "WorkdayUserProvisioningService", "UIErrorHandlingService", "$state", "$stateParams"];

  constructor(
    private $scope: IScope,
    private workdayUserProvisioningService: WorkdayUserProvisioningService,
    private uiErrorHandlingService: UIErrorHandlingService,
    private $state: StateService,
    private $stateParams: ISelectionMapService
  ) {}

  $onInit(): void {
    this.indicators = {};

    this.getJobLevels();
    this.selectionId = this.$stateParams.selectionId;
    if (this.selectionId) {
      this.getSelectionById();
    } else {
      this.selection = {
        name: "Provisioning selection",
        filters: [{ filterType: FilterType.ORGANIZATIONS, entries: [], include: true }],
        enabled: true,
      };
    }
    this.$scope.$on("saveModalClicked", () => {
      this.saveSelection();
    });
  }

  resetIndicator(indicator: keyof WizardSelectionCtrl["indicators"]): void {
    delete this.indicators[indicator];
  }

  saveSelection(): void {
    if (this.selection.id) {
      this.updateSelection();
    } else {
      this.createSelection();
    }
  }

  getJobLevels(): void {
    this.indicators.loadingJobLevels = {
      progress: true,
    };
    this.workdayUserProvisioningService
      .getJobLevels()
      .then((response) => {
        this.jobLevels = response;
        delete this.indicators.loadingJobLevels;
      })
      .catch((error) => {
        this.uiErrorHandlingService.handleModal(error);
        delete this.indicators.loadingJobLevels;
      });
  }

  getSelectionById(): void {
    this.indicators.loading = { progress: true };
    this.workdayUserProvisioningService
      .getSelection(this.selectionId)
      .then((response) => {
        this.selection = response;
        delete this.indicators.loading;
      })
      .catch((error) => {
        delete this.indicators.loading;
        this.uiErrorHandlingService.handleModal(error);
      });
  }

  updateSelection(): void {
    this.setSelectedEntries();
    this.indicators.loading = { progress: true };
    this.workdayUserProvisioningService
      .updateSelection(this.selection)
      .then(() => {
        this.broadcastSelectionUpdate();
      })
      .catch((error) => {
        delete this.indicators.loading;
        this.uiErrorHandlingService.handleModal(error);
      });
  }

  createSelection(): void {
    this.setSelectedEntries();
    this.indicators.loading = { progress: true };
    this.workdayUserProvisioningService
      .postSelection(this.selection)
      .then(() => {
        this.broadcastSelectionUpdate();
      })
      .catch((error) => {
        delete this.indicators.loading;
        this.uiErrorHandlingService.handleModal(error);
      });
  }

  private broadcastSelectionUpdate() {
    this.$scope.$root.$broadcast("selectionsUpdated");
    this.$state.go("^.^");
  }

  addFilter(): void {
    this.setSelectedEntries();
    this.selection.filters.push({
      filterType: FilterType.ORGANIZATIONS,
      entries: [],
      include: true,
    });
  }

  deleteFilter(index: number): void {
    this.selection.filters.splice(index, 1);
  }

  private setSelectedEntries(): void {
    this.selection.filters.forEach((filter) => {
      filter.entries = filter.selectedEntries;
    });
  }
}
